import { useTranslator } from '@bluebeam/react-i18n';
import { ModalStaticProperties } from 'components/ModalPortal/ModalPortal';
import React, { FC } from 'react';
import './modals.css';
import ModalStdHeader from './ModalStdHeader';

interface Props {
  handleClose: () => void;
}

const FileSelectNoticeModal: FC<Props> & ModalStaticProperties = ({
  handleClose,
}) => {
  const { translate } = useTranslator(['fileSelectionNoticeModal', 'buttons']);
  return (
    <div id="file-selection-modal" className="modal__content os">
      <ModalStdHeader text={translate('fileSelectionNoticeModal:header')} />
      <div className="h100 px5 py9">
        <div className="mb4">
          <div className="font-size-5 light">
            {translate('fileSelectionNoticeModal:content')}
          </div>
        </div>
      </div>
      <div className="row px5 py3 so-vw100 w100 bgd-white-2 modal__button-row">
        <button
          id="refresh-session-modal-logout-btn"
          className="btn btn-link"
          onClick={handleClose}
        >
          {translate('buttons:close')}
        </button>
      </div>
    </div>
  );
};

FileSelectNoticeModal.modalClasses = {
  overlay: `modal__overlay`,
  content: `modal__window modal--xs`,
};

export default FileSelectNoticeModal;
